import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  colWidget: "Widget",
  colShows: "Shows",
  colSize: "Size",
  colShow: "Show",
  notShown: "Not shown",
  complianceOnly: "Compliance only",
  full: "Full",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    colWidget: "Widget",
    colShows: "Affiche",
    colSize: "Taille",
    colShow: "Afficher",
    notShown: "Non affiché",
    complianceOnly: "Conformité uniquement",
    full: "Pleine largeur",
  },
  es_ES: {
    colWidget: "Widget",
    colShows: "Muestra",
    colSize: "Tamaño",
    colShow: "Mostrar",
    notShown: "No se muestra",
    complianceOnly: "Solo cumplimiento",
    full: "Completo",
  },
  pt_BR: {
    colWidget: "Widget",
    colShows: "Exibe",
    colSize: "Tamanho",
    colShow: "Exibir",
    notShown: "Não exibido",
    complianceOnly: "Somente compliance",
    full: "Inteiro",
  },
  de_DE: {
    colWidget: "Widget",
    colShows: "Zeigt",
    colSize: "Größe",
    colShow: "Anzeigen",
    notShown: "Nicht angezeigt",
    complianceOnly: "Nur Compliance",
    full: "Volle Breite",
  },
  it_IT: {
    colWidget: "Widget",
    colShows: "Mostra",
    colSize: "Dimensione",
    colShow: "Mostra",
    notShown: "Non mostrato",
    complianceOnly: "Solo compliance",
    full: "Intera",
  },
  ar: {
    colWidget: "الأداة",
    colShows: "المحتوى",
    colSize: "الحجم",
    colShow: "إظهار",
    notShown: "غير معروضة",
    complianceOnly: "للامتثال فقط",
    full: "كامل",
  },
  ja_JP: {
    colWidget: "ウィジェット",
    colShows: "表示内容",
    colSize: "サイズ",
    colShow: "表示",
    notShown: "非表示",
    complianceOnly: "コンプライアンスのみ",
    full: "全幅",
  },
  hi_IN: {
    colWidget: "विजेट",
    colShows: "क्या दिखाता है",
    colSize: "आकार",
    colShow: "दिखाएँ",
    notShown: "नहीं दिखाया गया",
    complianceOnly: "केवल अनुपालन",
    full: "पूर्ण",
  },
  zh_CN: {
    colWidget: "小组件",
    colShows: "显示内容",
    colSize: "尺寸",
    colShow: "显示",
    notShown: "不显示",
    complianceOnly: "仅限合规",
    full: "整行",
  },
  zh_TW: {
    colWidget: "小工具",
    colShows: "顯示內容",
    colSize: "大小",
    colShow: "顯示",
    notShown: "不顯示",
    complianceOnly: "僅限合規",
    full: "整列",
  },
  nl_NL: {
    colWidget: "Widget",
    colShows: "Toont",
    colSize: "Grootte",
    colShow: "Tonen",
    notShown: "Niet getoond",
    complianceOnly: "Alleen compliance",
    full: "Volledig",
  },
  nb_NO: {
    colWidget: "Widget",
    colShows: "Viser",
    colSize: "Størrelse",
    colShow: "Vis",
    notShown: "Vises ikke",
    complianceOnly: "Kun compliance",
    full: "Hel",
  },
  sv_SE: {
    colWidget: "Widget",
    colShows: "Visar",
    colSize: "Storlek",
    colShow: "Visa",
    notShown: "Visas inte",
    complianceOnly: "Endast compliance",
    full: "Hel",
  },
  fi_FI: {
    colWidget: "Widget",
    colShows: "Näyttää",
    colSize: "Koko",
    colShow: "Näytä",
    notShown: "Ei näytetä",
    complianceOnly: "Vain compliance",
    full: "Koko leveys",
  },
  da_DK: {
    colWidget: "Widget",
    colShows: "Viser",
    colSize: "Størrelse",
    colShow: "Vis",
    notShown: "Vises ikke",
    complianceOnly: "Kun compliance",
    full: "Hel",
  },
  is_IS: {
    colWidget: "Græja",
    colShows: "Sýnir",
    colSize: "Stærð",
    colShow: "Sýna",
    notShown: "Ekki sýnt",
    complianceOnly: "Aðeins regluvarsla",
    full: "Full breidd",
  },
};
